import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild , ElementRef } from '@angular/core';
import { AudioRecordingService } from '../audio-recording.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-sample',
  templateUrl: './sample.component.html',
  styleUrls: ['./sample.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

 
export class SampleComponent implements OnInit{

 
  video: any;
  isPlaying = false;
  displayControls = true;
  isAudioRecording = false;
  isVideoRecording = false;
  audioRecordedTime;
  videoRecordedTime;
  audioBlobUrl;
  videoBlobUrl;
  audioBlob;
  videoBlob;
  audioName;
  dataurl : any;
  videoName;
  audioStream;
  videoStream: MediaStream;
  audioConf = { audio: true}
 

  constructor(
    private ref: ChangeDetectorRef,
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer
  ) {


    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;
      this.ref.detectChanges();
 });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.audioRecordedTime = time;
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.audioBlob = data.blob;
      this.audioName = data.title;
      this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
      blobToBase64(data.blob).then(res => {
        // console.log(res);
        this.dataurl = res;  
        let b64 = this.dataurl.replace(/^data:.+;base64,/, '');
        localStorage.setItem("audioblob", b64);
        console.log(localStorage.getItem('audioblob'));

       });
      this.ref.detectChanges();
    });
  }

  ngOnInit() {
    
  }



  startAudioRecording() {
    if (!this.isAudioRecording) {
      this.isAudioRecording = true;
      // this.audioRecordingService.startRecording();
    }
  }

  

  stopAudioRecording() {
    if (this.isAudioRecording) {
      // this.audioRecordingService.stopRecording(); commented by subbu
      this.isAudioRecording = false;
    }
  }

  clearAudioRecordedData() {
    this.audioBlobUrl = null;
  }
  
}

const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};